import React, { useState } from 'react';
import axios from 'axios';
import Header from '../components/Header';
import Footer from '../components/Footer';
import AnimateReveal from '../components/AnimateReveal';
import { Link } from 'react-router-dom';


import supportBg from "../../src/assets/images/support.png"
import trial from "../../src/assets/images/trial-bg.png"


const Support = () => {
  const [formData, setFormData] = useState({
    email: '',
    telegram: '',
    message: ''
  });
  const [agreed, setAgreed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const faqs = [
    {
      id: 1,
      question: 'Qu\'est-ce que H4KIG STREAM?',
      answer: 'H4KIG STREAM est un service de streaming qui vous permet de regarder des films et des séries à la demande.',
      open: true
    },
    {
      id: 2,
      question: 'Combien coûte H4KIG STREAM?',
      answer: 'Nous proposons trois plans d\'abonnement : 1 Mois (1.99€), 6 Mois (11.99€), et 12 Mois (23.99€).',
      open: false
    },
    {
      id: 3,
      question: 'Quel contenu est disponible sur H4KIG STREAM?',
      answer: 'H4KIG STREAM propose une large sélection de films et de séries TV dans divers genres.',
      open: false
    },
    {
      id: 4,
      question: 'Comment puis-je regarder H4KIG STREAM?',
      answer: 'Vous pouvez regarder H4KIG STREAM sur n\'importe quel appareil avec un navigateur web. Abonnez-vous simplement et commencez à regarder !',
      open: false
    },
    {
      id: 5,
      question: 'Comment m\'inscrire à H4KIG STREAM?',
      answer: 'Cliquez sur le bouton Inscription, remplissez vos informations et choisissez un plan d\'abonnement.',
      open: false
    },
    {
      id: 6,
      question: 'H4KIG STREAM propose-t-il un essai gratuit?',
      answer: 'Actuellement, nous proposons des abonnements payants. Consultez notre page d\'abonnements pour les dernières offres.',
      open: false
    },
    {
      id: 7,
      question: 'Comment contacter le support client de H4KIG STREAM?',
      answer: 'Vous pouvez nous contacter via cette page de support en remplissant le formulaire de contact.',
      open: false
    },
    {
      id: 8,
      question: 'Quels sont les modes de paiement de H4KIG STREAM?',
      answer: 'Nous acceptons les paiements en cryptomonnaie via OxaPay et les paiements par carte via nos partenaires de paiement.',
      open: false
    }
  ];

  const [openFaqs, setOpenFaqs] = useState(faqs.map(f => f.id === 1));

  const toggleFaq = (id) => {
    setOpenFaqs(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
    setMessage('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!agreed) {
      setError('Veuillez accepter les Conditions d\'utilisation et la Politique de confidentialité');
      return;
    }

    setLoading(true);
    setError('');
    setMessage('');

    try {
      await axios.post('/api/contact', formData);
      setMessage('Message envoyé avec succès ! Nous vous répondrons bientôt.');
      setFormData({ email: '', telegram: '', message: '' });
      setAgreed(false);
    } catch (err) {
      setError(err.response?.data?.message || 'Échec de l\'envoi du message');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#141414]">
      <Header />
      
      <div className="container mx-auto px-4 py-12">
        {/* Welcome Section */}
        <AnimateReveal animation="fadeUp">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
          <div>
            <h1 className="text-4xl font-bold text-white mb-4">Bienvenue sur notre page de support !</h1>
            <p className="text-gray-300 mb-8">
              Nous sommes là pour vous aider avec tous les problèmes que vous pourriez rencontrer avec notre produit.
            </p>
            <img src={supportBg} alt="Support background" />
          </div>

          <div className="bg-[#0F0F0F] rounded-lg p-8">
            <h2 className="text-2xl font-bold text-white mb-6">Contactez-nous</h2>
            
            {message && (
              <div className="mb-4 p-3 bg-green-900/50 border border-green-700 rounded text-green-200 text-sm">
                {message}
              </div>
            )}
            
            {error && (
              <div className="mb-4 p-3 bg-red-900/50 border border-red-700 rounded text-red-200 text-sm">
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-4">
              <div className='flex flex-col md:flex-row items-center gap-2 w-full jutify-center'>
                <div className='w-full'>
                  <label className="block text-white mb-2">Email</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Entrez votre email"
                    className="w-full px-4 py-3 bg-[#141414] text-white rounded-lg border border-[#262626] focus:border-white focus:outline-none"
                    required
                  />
                </div>

                <div className='w-full'>
                  <label className="block text-white mb-2">Nom d'utilisateur Telegram</label>
                  <input
                    type="text"
                    name="telegram"
                    value={formData.telegram}
                    onChange={handleChange}
                    placeholder="Entrez @username"
                    className="w-full px-4 py-3 bg-[#141414] text-white rounded-lg border border-[#262626] focus:border-white focus:outline-none"
                  />
                </div>                
              </div>

              <div>
                <label className="block text-white mb-2">Message</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Entrez votre message"
                  rows="5"
                  className="w-full px-4 py-3 bg-[#141414] text-white rounded-lg border border-[#262626] focus:border-white focus:outline-none"
                  required
                />
              </div>

              <div className="flex items-center">
                <input
                  type="checkbox"
                  id="agree"
                  checked={agreed}
                  onChange={(e) => setAgreed(e.target.checked)}
                  className="w-4 h-4 text-white bg-[#141414] border-[#262626] rounded focus:ring-white"
                />
                <label htmlFor="agree" className="ml-2 text-gray-300 text-sm">
                  J'accepte les Conditions d'utilisation et la Politique de confidentialité
                </label>
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full py-3 bg-white text-gray-900 rounded-lg hover:bg-gray-100 transition font-semibold disabled:opacity-50"
              >
                {loading ? 'Envoi...' : 'Envoyer le message'}
              </button>
            </form>
          </div>
        </div>
        </AnimateReveal>

        <AnimateReveal animation="fadeUp" delay={100}>
        <div className="bg-[#141414] border border-[#262626] rounded-2xl overflow-hidden mb-28">
          <div className="grid grid-cols-1 md:grid-cols-2">
            {faqs.map((faq, idx) => {
              const isOpen = !!openFaqs[faq.id];
              const number = String(idx + 1).padStart(2, '0');
              return (
                <div
                  key={faq.id}
                  className="border-b border-[#262626] last:border-b-0 md:border-r md:odd:border-r md:even:border-r-0 md:[&:nth-last-child(-n+2)]:border-b-0"
                >
                  <button
                    onClick={() => toggleFaq(faq.id)}
                    className="w-full text-left px-8 py-8 hover:bg-white/[0.02] transition-colors duration-200"
                  >
                    {/* 3-column layout */}
                    <div className="flex items-start gap-6">
                      {/* Number badge */}
                      <div className="w-12 h-12 rounded-xl bg-[#1C1C1C] border border-[#2A2A2A] flex items-center justify-center text-white/70 font-medium text-sm flex-shrink-0">
                        {number}
                      </div>
                      
                      {/* Question + Answer */}
                      <div className="flex-1 min-w-0 pt-1">
                        <h3 className="text-white/90 text-base font-normal leading-relaxed pr-4">
                          {faq.question}
                        </h3>
                        {isOpen && (
                          <p className="mt-4 text-[#9CA3AF] text-[15px] leading-relaxed">
                            {faq.answer}
                          </p>
                        )}
                      </div>
                      
                      {/* Icon pinned right */}
                      <div className="flex-shrink-0 pt-1">
                        <span className="text-white/80 text-xl font-light leading-none block w-5 text-center">
                          {isOpen ? '−' : '+'}
                        </span>
                      </div>
                    </div>
                  </button>
                </div>
              );
            })}
          </div>
        </div>
        </AnimateReveal>

          <div className="container mx-auto px-4 mb-12">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src={trial}
                alt="Free trial background"
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 " />
              <div className="relative z-10 p-8 md:p-20 ">
                  <div className='flex items-center justify-between flex-col md:flex-row'>
                      <div className='flex flex-col items-start'>
                        <h2 className="text-center md:text-start text-3xl md:text-4xl font-semibold text-white mb-4">
                          Des milliers de films et séries, dès maintenant !
                        </h2>

                        <p className="text-gray-300 mb-6 text-center md:text-start">
                          Accès illimité au catalogue complet en Full HD 1080p, sans publicité.<br />
                          Compatible TV, PC, Mobile et Mac.
                        </p>                
                    </div>
                    <Link
                      to="/subscriptions"
                      className="inline-flex items-center justify-center px-6 py-3
                                bg-white text-gray-900 rounded-xl
                                hover:bg-gray-100 transition font-semibold"
                    >
                      Accès immédiat
                    </Link>
                  </div>
              </div>

            </div>
          </div>
      </div>

      <Footer />
    </div>
  );
};

export default Support;
